const introspection = require('graphql-introspections/queue.json')

const utils = require('sci/utils')

const {
    InMemoryCache,
    gql,
    ApolloClient,
    HttpLink
} = require('@apollo/client/core')

const queueUrl = utils.queueUrl('v2/graphql')

let state = null

module.exports = () => {
    if (state) {
        return state.client
    } else {
        const link = new HttpLink({
            uri: queueUrl,
            headers: {
                authorization: `Bearer ${window.__sessionToken}`
            },
        });

        const client = new ApolloClient({
            link: link,
            cache: new InMemoryCache({
                possibleTypes: introspection.possibleTypes
            }),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
                mutate: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
            }
        })

        state = { client }

        return client
    }
}


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/queue-client.js